/******************************************************************************
 * useConfirmation Hook
 *
 * Re-usable confirmation modal hook
 *
 * Author:         Robert Bleeks
 * Company:        Sleeping Giant Technologies Ltd
 ******************************************************************************/

import {
    useState
} from "react";

export default function useConfirmation() {

    /**************************************************************************
     * STATE
     *************************************************************************/

    const [open, setOpen] =
        useState(false);

    const [title, setTitle] =
        useState("");

    const [message, setMessage] =
        useState("");

    const [confirmText, setConfirmText] =
        useState("Confirm");

    const [cancelText, setCancelText] =
        useState("Cancel");

    const [confirmColor, setConfirmColor] =
        useState(null);

    const [hideCancel, setHideCancel] =
        useState(false);

    const [resolver, setResolver] =
        useState(null);

    /**************************************************************************
     * SHOW CONFIRMATION
     *************************************************************************/

    function confirm(options) {

        return new Promise(function (resolve) {

            setTitle(
                options.title || "Confirmation"
            );

            setMessage(
                options.message || ""
            );

            setConfirmText(
                options.confirmText || "Confirm"
            );

            setCancelText(
                options.cancelText || "Cancel"
            );

            setConfirmColor(
                options.confirmColor || null
            );

            setHideCancel(
                options.hideCancel || false
            );

            setResolver(function () {

                return resolve;
            });

            setOpen(true);
        });
    }

    /**************************************************************************
     * HANDLE CONFIRM
     *************************************************************************/

    function handleModalConfirm() {

        setOpen(false);

        if (resolver) {

            resolver(true);
        }
    }

    /**************************************************************************
     * HANDLE CANCEL
     *************************************************************************/

    function handleModalCancel() {

        setOpen(false);

        if (resolver) {

            resolver(false);
        }
    }

    /**************************************************************************
     * MODAL PROPS
     *************************************************************************/

    const modalProps = {

        open: open,

        title: title,

        message: message,

        confirmLabel: confirmText,

        cancelLabel: cancelText,

        confirmColor: confirmColor,

        hideCancel: hideCancel
    };

    /**************************************************************************
     * EXPORTS
     *************************************************************************/

    return {

        confirm,

        modalProps,

        handleModalConfirm,

        handleModalCancel
    };
}